module.exports = __webpack_public_path__ + "static/media/video-metacognition-en.73cd7084.vtt";